/**
 * @module FieldControls
 */
import { InputAdornment, TextField, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
/**
 * Field control that represents a FileName field. Available values will be populated from the FieldSettings.
 */
export const FileName = props => {
  var _props$localization, _props$fieldValue;
  const localization = deepMerge(defaultLocalization.fileName, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.fileName);
  const valueInitialState = ((_props$fieldValue = props.fieldValue) === null || _props$fieldValue === void 0 ? void 0 : _props$fieldValue.replace(/<[^>]*>/g, '').split('.').slice(0, -1).join('.')) || props.actionName === 'new' && changeTemplatedValue(props.settings.DefaultValue) || '';
  const [value, setValue] = useState(valueInitialState);
  const getExtension = () => {
    if (props.fieldValue && props.fieldValue.indexOf('.') > -1) {
      return props.fieldValue.substr(props.fieldValue.lastIndexOf('.') + 1);
    }
    if (props.extension) {
      return props.extension;
    }
    return '';
  };
  const handleChange = event => {
    var _props$fieldOnChange;
    setValue(event.target.value);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, `${event.target.value}.${getExtension()}`);
  };
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(TextField, {
        autoFocus: props.autoFocus,
        name: props.settings.Name,
        id: props.settings.Name,
        label: props.settings.DisplayName,
        placeholder: props.settings.DisplayName,
        value: value,
        onChange: handleChange,
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, /*#__PURE__*/React.createElement("span", null, `.${getExtension()}`))
        },
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly,
        fullWidth: true,
        helperText: props.hideDescription ? undefined : props.settings.Description
      });
    case 'browse':
    default:
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true
      }, props.fieldValue || localization.noValue));
  }
};
//# sourceMappingURL=file-name.js.map